var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRank2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 86,
  height: 101,
  viewBox: "0 0 86 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd_1_367)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_1_367)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M56.228 76H20.476C21.0227 73.376 21.788 70.9707 22.772 68.784C23.756 66.5427 24.986 64.4107 26.462 62.388C27.938 60.3653 29.66 58.3973 31.628 56.484C33.6507 54.516 35.9467 52.548 38.516 50.58L44.174 46.152C45.7047 44.9493 46.962 43.8833 47.946 42.954C48.9847 41.97 49.8047 40.986 50.406 40.002C51.062 39.018 51.5813 37.9793 51.964 36.886C52.3467 35.738 52.702 34.3987 53.03 32.868C53.1393 32.376 53.2213 31.9113 53.276 31.474C53.3307 31.0367 53.358 30.5993 53.358 30.162C53.358 27.1553 51.8273 25.652 48.766 25.652C47.29 25.652 46.06 25.9527 45.076 26.554C44.092 27.1553 43.272 27.9753 42.616 29.014C41.96 30.0527 41.4133 31.2553 40.976 32.622C40.5387 33.9887 40.156 35.4373 39.828 36.968H28.512L29.004 34.754C30.2067 29.342 32.5027 25.1873 35.892 22.29C39.336 19.3927 44.2287 17.944 50.57 17.944C55.5447 17.944 59.2073 18.928 61.558 20.896C63.9633 22.8093 65.166 25.5973 65.166 29.26C65.166 31.6653 64.8927 33.9067 64.346 35.984C63.7993 38.0067 62.952 39.9473 61.804 41.806C60.656 43.6647 59.2347 45.4413 57.54 47.136C55.9 48.8307 53.9867 50.5253 51.8 52.22L43.928 58.288C41.8507 59.8733 40.156 61.4313 38.844 62.962C37.5867 64.438 36.712 65.7227 36.22 66.816H58.114L56.228 76Z",
  fill: "#FAFAFA"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd_1_367",
  x: -1,
  y: 0.94397,
  width: 86.166,
  height: 100.056,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_367"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_1_367",
  result: "effect2_dropShadow_1_367"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_1_367",
  result: "effect3_dropShadow_1_367"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_367",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_1_367",
  x: 16.4761,
  y: 17.944,
  width: 52.6899,
  height: 66.056,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_367"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_367",
  result: "shape"
})))));
export default SvgRank2;